import { createSlice } from "@reduxjs/toolkit";
import { setMenuService } from "./services/setMenuService";

export interface MenuItem {
    id: any;
    menuItemId: string;
    description: string;
    imageUrl: string;
    displayName: string;
    price: number;
}

export interface SetMenu {
    availableDays: number[];
    isAvailable: boolean;
    items: MenuItem[];
    description: string;
    displayName: string;

    id: string;
    imageUrl: string;
    price: any;
    createdAt: {
        _nanoseconds: number;
        _seconds: number;
    };
    status: string;
    restaurantId: string;
    availableItemCount: number;
    allergenInformation: string[];
    foodAttributes: string[];
    supportPortionSizes: boolean;
    portions: Portion[];
    quantity?: number;
    category?: any;
    portionLabel?: string;
    isCooporateProduct?: boolean;
    organizationIds?: string[];
}

export interface Portion {
    displayName: string;
    additionalCost: number;
}

export interface CreateSetMenuRequest {
    restaurantId: string;
    items: MenuItem[];
    description: string;
    displayName: string;
    abbreviation?: string;
    imageReference?: string;
    imageUrl?: string;
    allergenInformation?: string[];
    foodAttributes?: string[];
    supportPortionSizes?: boolean;
    portions?: Portion[];
    portionSize?: string;
    portionPrice?: string;
    category?: any;
    filterTags: string[],
    productId: string,
    supportsPreOrdering: boolean;
    tinyId?:number;
}

export interface UpdateSetMenuRequest {
    restaurantId: string;
    setMenuId: any;
    items: {
        menuItemId: string;
        description: string;
        imageUrl?: string;
        displayName: string;
        price: number;
    }[];
    description: string;
    displayName: string;
    allergenInformation?: string[];
    foodAttributes?: string[];
    supportPortionSizes?: boolean;
    portions?: Portion[];
    category?: any;
}

export interface MenuItemOptionType {
    displayName: string;
    price: number;
    itemId: string;
    imageUrl: string;
    description: string;
    itemType: string;
}

export interface SetMenuImageUpdateRequest {
    imgRef: string;
    restaurantId: string;
    setMenuId: string;
}

interface SetMenuState {
    setMenus: SetMenu[];
    loading: boolean;
    error: any;
    rowsPerPage: number;
}

const initialState: SetMenuState = {
    setMenus: [],
    loading: false,
    error: null,
    rowsPerPage: 10,
};

const setMenuSlice = createSlice({
    name: "setMenu",
    initialState,
    reducers: {
        getSetMenusStart(state) {
            state.loading = true;
            state.error = null;
        },
        getSetMenusSuccess(state, action) {
            state.setMenus = action.payload;
            state.loading = false;
            state.error = null;
        },
        getSetMenusFailure(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        clearRowsPerPage(state) {
            state.rowsPerPage = 10;
        },
        setComboItems(state, action) {
            state.setMenus = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            setMenuService.endpoints.getMenuListByRestaurantId.matchFulfilled,
            (state, { payload }) => {
                state.setMenus = payload.setMenuList;
            }
        );
    },
});

export const { getSetMenusStart, getSetMenusSuccess, getSetMenusFailure, setRowsPerPage, clearRowsPerPage,setComboItems } =
    setMenuSlice.actions;

// export const selectSetMenuById = (state: RootState, id: any) =>
//   state.setMenu.setMenus.find((menu: SetMenu) => menu.id === id);

// export const selectSetMenuByDisplayName = (state: RootState, displayName: any) =>
//   state.setMenu.setMenus.find((menu: SetMenu) => menu.displayName === displayName);

export default setMenuSlice.reducer;
